'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  dense: _propTypes2.default.bool,
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  dense: false
};

/** Prop Receivers */
var styleProps = function styleProps(_ref) {
  var themeFromProvider = _ref.theme,
      colorScheme = _ref.colorScheme,
      focus = _ref.focus,
      disabled = _ref.disabled;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.selectBox.message.style;

  var source = null;

  if (!disabled) {
    if (colorScheme !== 'neutral') source = path[colorScheme];else if (focus) source = path.focus;else source = path;
  } else {
    source = path.disabled;
  }

  var _source = source,
      fontColor = _source.fontColor;


  return 'color: ' + fontColor + ';';
};

var baseProps = function baseProps(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.selectBox.message,
      messageSelectSpacing = _theme$reactackle$com.messageSelectSpacing,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight;


  return '\n    margin-top: ' + (0, _reactackleCore.getValueString)(messageSelectSpacing) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n  ';
};

/** STYLES */
var MessageStyled = exports.MessageStyled = _styledComponents2.default.div.withConfig({
  displayName: 'MessageStyled'
})(['flex-grow:1;', ';', ';', ';'], baseProps, styleProps, (0, _reactackleCore.transition)('color'));

MessageStyled.propTypes = propTypes;
MessageStyled.defaultProps = defaultProps;
MessageStyled.displayName = 'MessageStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-selectbox/dist/styles/MessageStyled.js
// module id = 225
// module chunks = 0